import React from "react";
import {Button, Badge, Row, Col} from "reactstrap";
import Confetti from 'react-confetti';
import { connect } from 'react-redux';
import reduxHelper from "./../../../../helper/index.js";

class Congratulations extends React.Component {

	constructor(props){

		super(props);
		this.state = {
			awardedBadges: [],
			certificate: null
		};
		this.helper = new reduxHelper(this.props);
		window.congratulations = this;

	}

	componentDidMount() {
		// As badges e certificado vem diretamente do state do ViewLesson
		// (preenchidos pelo backend ao salvar o progresso em POST /progress/)
		var badges = [];
		var cert = null;

		if (this.props.state && this.props.state.awardedBadges) {
			badges = this.props.state.awardedBadges;
		}
		if (this.props.state && this.props.state.awardedCertificate) {
			cert = this.props.state.awardedCertificate;
		}

		this.setState({ awardedBadges: badges, certificate: cert });
	}

	render(){

		var translate = this.props.translate || {};
		var hasBadges = this.state.awardedBadges.length > 0;
		var hasCert = this.state.certificate !== null;

		return(<React.Fragment>
			<Confetti gravity={0.03} wind={0.01} initialVelocityX={4} initialVelocityY={0.6} numberOfPieces={hasCert ? 50 : 20} width={this.props.state.width+'px'} height={this.props.state.height+'px'} />
			<div className="congratulations" style={{zIndex:"9999",position:"relative"}}>
				<center>
					<img alt="..." src="/images/trophy.png" />
					<h1>{translate['parabens'] || 'Parabéns'}!</h1>
					<font>{translate['voce_finalizou_essa_unit'] || 'Você finalizou essa unidade!'}</font>

					{/* Badges conquistadas */}
					{hasBadges && (
						<div className="mt-3">
							<h4 style={{color: '#FFD700'}}>
								<i className="fas fa-award mr-2" />
								{translate['badges_conquistadas'] || 'Badges Conquistadas!'}
							</h4>
							<Row className="justify-content-center mt-2">
								{this.state.awardedBadges.map((badge, index) => (
									<Col key={index} xs="auto" className="mb-2">
										<Badge
											color="warning"
											pill
											style={{ fontSize: '0.9rem', padding: '8px 16px' }}
										>
											<i className={(badge.icon || 'fas fa-star') + ' mr-1'} />
											{badge.name || 'Nova Badge!'}
										</Badge>
									</Col>
								))}
							</Row>
						</div>
					)}

					{/* Certificado gerado */}
					{hasCert && (
						<div className="mt-3 p-3" style={{
							backgroundColor: '#dc354520',
							borderRadius: '10px',
							border: '2px solid #dc3545',
							display: 'inline-block'
						}}>
							<h4 style={{color: '#dc3545'}}>
								<i className="fas fa-graduation-cap mr-2" />
								{translate['certificado_emitido'] || 'Certificado Emitido!'}
							</h4>
							<p className="mb-1">
								{translate['codigo_certificado'] || 'Código'}: <strong>{this.state.certificate.code}</strong>
							</p>
							<Button
								color="danger"
								size="sm"
								onClick={() => this.props.history.push('/achievements')}
							>
								<i className="fas fa-eye mr-1" />
								{translate['ver_certificado'] || 'Ver Certificado'}
							</Button>
						</div>
					)}

					<br/><br/>
					<Button onClick={ () => this.props.history.push('/myclassroom/'+this.props.classroom) } color="success" size="sm" type="button">
						<i className="fas fa-undo"></i> {translate['voltar_nas_units'] || 'Voltar nas Units'}
					</Button>
					{' '}
					<Button onClick={ () => this.props.history.push('/achievements') } color="warning" size="sm" type="button">
						<i className="fas fa-award"></i> {translate['ver_conquistas'] || 'Ver Conquistas'}
					</Button>
				</center>
			</div>

		</React.Fragment>);

	}

}

export default connect(state =>({

	languages: state.language,
	translate: state.translate,
	accesslevel: state.accesslevel,
	permission: state.permission,
	user: state.user,
	magictools: state.magictools,
	badge: state.badge

  }))(Congratulations);
